import { sitApi } from './sitApiClient';

// Module-scope cache so we don't refetch on every Select mount. DIDs change
// rarely (terraform re-apply); a fresh page-load is sufficient cache invalidation.
let cachedDidsPromise = null;

/**
 * GET /dids — returns `[{ did, primary }]` for this env.
 *
 * Backend reads from SSM `/presidio-sit/{env}/allowed-fromdids`. First entry
 * is the primary (default selection in the Select). Engineers can override
 * per-plan to dial from a reserve DID (e.g., batch concurrency / per-engagement
 * audit).
 */
export function listDids() {
  if (!cachedDidsPromise) {
    cachedDidsPromise = sitApi.get('/dids')
      .then((res) => res.data?.dids ?? [])
      .catch((err) => {
        // Reset on error so the next caller can retry.
        cachedDidsPromise = null;
        throw err;
      });
  }
  return cachedDidsPromise;
}
